// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1rlLR","infoBtn":"quickbooks_infoBtn__cz9DD","formBox":"quickbooks_formBox__2f7yb","formFooter":"quickbooks_formFooter__1aD-r"};